import { FC, ReactNode } from 'react'
import clsx from 'clsx'
import ReactHtmlParser from 'react-html-parser'
import { Icon } from '@iconify/react'

import { Attachments } from '@pepper/ui'

import styles from './_.module.css'

interface Props {
  title: string
  rating?: number
  titlePostfix?: ReactNode
  issues: string[]
  issuesPrefix?: ReactNode
  message: string
  attachments?: Attachment[]
  type?: 'warn' | 'danger' | 'success'
  showRating?: boolean
}

const FeedbackActivity: FC<Props> = ({
  title,
  rating,
  titlePostfix,
  issues = [],
  issuesPrefix,
  message,
  attachments = [],
  type,
  showRating = false,
}) => {
  return (
    <div
      className={clsx(styles.feedbackActivityContainer, type && styles[type])}
    >
      <div className={styles.title}>
        <p>{title}</p>
        {titlePostfix ?? ''}
      </div>
      <div className={styles.feedbackPoints}>
        <div className={styles.pointsHeading}>
          {!showRating || !rating ? (
            <span className={styles.boldTitle}>Issues:</span>
          ) : (
            <div>
              {Array.from(Array(rating).keys()).map(val => (
                <Icon
                  key={val}
                  icon="lucide:star"
                  height={24}
                  width={24}
                  className={styles.starIcon}
                />
              ))}
              {5 - rating > 0 &&
                Array.from(Array(5 - rating).keys()).map(val => (
                  <Icon
                    key={val}
                    icon="lucide:star"
                    height={24}
                    width={24}
                    color="var(--color-gray-300)"
                  />
                ))}
            </div>
          )}
        </div>
        <div className={styles.issueList}>
          {issues.length > 0 ? (
            issues.map((issue, index) => (
              <span key={index} className={styles.issueContainer}>
                {issuesPrefix ?? ''}
                <span>{issue}</span>
              </span>
            ))
          ) : (
            <span className={styles.issueContainer}>
              {type !== 'success' ? 'N/A' : ''}
            </span>
          )}
        </div>
      </div>
      {ReactHtmlParser(message ? message : '')}
      {attachments.length > 0 ? (
        <Attachments attachments={attachments ?? []} />
      ) : null}
    </div>
  )
}

export default FeedbackActivity
